var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Component_867_1",
    "data-name": "Component 867 \\u2013 1",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15848",
    "data-name": "Group 15848",
    transform: "translate(-459 -156)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9538",
    "data-name": "Rectangle 9538",
    width: 24,
    height: 24,
    rx: 4,
    transform: "translate(459 156)",
    fill: "#f4f4f4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30358",
    "data-name": "Path 30358",
    d: "M16284.233,16217a2.249,2.249,0,0,1-2.239-2.033l-1.138-11.461h-1.02a.831.831,0,1,1,0-1.661h4.139v-2.01a.832.832,0,0,1,.826-.835h6.395a.836.836,0,0,1,.832.835v2.01h4.139a.831.831,0,1,1,0,1.661h-1.021l-1.145,11.461a2.24,2.24,0,0,1-2.244,2.033Zm-.576-2.2a.58.58,0,0,0,.584.533h7.516a.581.581,0,0,0,.585-.533l1.13-11.295h-10.944Zm1.979-12.956h4.725v-1.175h-4.725Zm4.232,12.04a.833.833,0,0,1-.214-.633l.71-7.813a.836.836,0,0,1,.839-.755h.064a.847.847,0,0,1,.76.907l-.715,7.814a.82.82,0,0,1-.826.751A.811.811,0,0,1,16289.869,16213.885Zm-2.7-.556v-7.814a.831.831,0,1,1,1.661,0v7.814a.831.831,0,0,1-1.661,0Zm-2.481.072-.71-7.811a.811.811,0,0,1,.189-.608.834.834,0,0,1,.564-.3c.024,0,.049,0,.077,0a.844.844,0,0,1,.827.759l.709,7.813a.825.825,0,0,1-.826.9A.824.824,0,0,1,16284.686,16213.4Z",
    transform: "translate(-15817.002 -16040)",
    fill: "#6b6e71"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.0ab2f93a9a5eacdc61d97a4b4e9c23b4.svg";
export { ForwardRef as ReactComponent };